// extracted by mini-css-extract-plugin
export default {"steps":"style_steps__omLUW"};